import { router } from 'expo-router';
import { View } from 'smoothie';

import GoalsSummary from '../../goals/components/summary/GoalsSummary';
import { RoadmapScreenHeader } from './RoadmapScreenHeader';

export const RoadmapTasks = () => {
    return (
        <View flex={1}>
            <RoadmapScreenHeader
                title="Tasks"
                hasBackButton={true}
                hasMessagingButton={true}
                onBack={() => {
                    router.canGoBack()
                        ? router.back()
                        : router.navigate('/home/roadmap');
                }}
            />
            <GoalsSummary />
        </View>
    );
};
